const general = {
  edit: 'Edit',
  cancel: 'Cancel',
  view: 'view',
  back: 'Back',
  selectAndBack: 'select and back ',
  start: 'Start',
  end: 'End',
  price: 'Price',
  discount: 'Discount',
  toman: 'Toman',
  company: 'Company',
  code: 'code',
  free: 'Free',
  total: 'All',
  yes: 'Yes',
  no: 'No',
  all: 'All',
  delete: 'Delete',
  first: 'First',
  last: 'Last',
  category: 'category',
  images: 'Images',
  save: 'Save',
  aboutMe: 'About Me',
  share: 'Share',
  copyRedlink: 'Copy REDLink',
};

const exceptions = {
  exception0: 'An unknown error has occurred!',
  exception1: 'The information entered is invalid!',
  exception2: 'Email is not valid',
  exception3: 'You are already registered',
  exception4: 'verification failed',
  exception5: 'Previous password entered incorrectly',
  exception6: 'An internal error has occurred',
  exception7: 'Server error occurred!',
  exception8: 'You are already a Pro user!',
  exception9: 'An external error has occurred!',
  exception10: 'A security error has occurred',
  exception11: 'A page with this name is now available',
  exception12: 'You have already used the dedicated address',
  exception13: 'Categories are now available',
  exception14: 'Page not found with this name!',
  exception15: 'The submitted file format is not valid',
  exception16: 'The uploaded file size is not valid',
  exception17: 'Implementation not completed',
  exception18: 'URL is not valid',
  exception19: 'This category is used in the product or post',
  exception20: 'The active theme cannot be removed.',
  exception21: 'An order has been recorded for this product.',
  exception22: 'Page not found',
  exception23: 'Dedicated address is not selectable',
  exception24: 'There must be at least one active tab',
  exception25: `There is no available card. Please buy new card(s)`,
  exception26: 'کد فعالسازی اشتباه است',
  exception27: 'شماره تلفن معتبر نیست',
  exception29: 'حداقل تعداد حروف برای نام صفحه ۴ می باشد.',
};

const limitations = {
  limitation1: (minLength) =>
    `حداقل تعداد حروف برای نام صفحه در اشتراک رایگان ${minLength} حرف می باشد.`,
};

const resume = {
  education: 'Education',
  experience: 'Experience',
  addNewEducation: 'New education',
  addNewExperience: 'New experience',
  addNewSkill: 'New skill',
  newEduction: 'New education',
  newExperience: 'New experience',
  newSkill: 'New skill',
  university: 'University',
  degree: 'Degree',
  major: 'Major',
  start: 'Start',
  end: 'End',
  date: 'Date',
  keepYourResumeUpToDate: 'Keep your resume up to date',
  new: 'New',
  talkAboutYourself: 'Tell me about yourself',
  bioDescription: 'A summary of what you are and can accomplish',
  skills: 'Skills',
  skillsDescription: 'A summary of what you are and can accomplish',
  workHistory: 'Work history',
  workHistoryDescription: 'Enter your job history',
  educationalHistory: 'Educational history',
  educationalHistoryDescription: 'Enter your Educational history',
  featuredProjects: 'Sample projects',
  featuredProjectsDescription:
    'Sample projects will be called from your gallery and you will need to enter in the gallery before selecting.',
  achievements: 'Achievements',
  achievementsDescription: 'Achievements, Documents and description',
  contactInfo: 'Contact info',
  contactInfoDescrption:
    'Contact information is displayed only for people looking for a job or project',
  socialMedia: 'Social medias',
  socialMediaDescription: 'You need to save the information in the links',
  jobStatus: 'Job status',
  working: 'Working',
  openToWork: 'Open to work',
  newAchievement: 'New achievement',
  achievement: 'Title',
  competition: 'location',
  more: 'more',
  less: 'less',
  showAll: 'show all',
  scanToAccessMyRedlink: 'Scan to access my Redlink',
};

const statistics = {
  dashboard: 'Statistics',

  pageViewStat: 'Page view status',
  todayPageView: 'Today page view ',
  todayPageClick: 'Today page click',
  allPageView: 'All page view',
  linkViewStat: 'Link View stats',
  mostTodayPopularLinkView: 'Most today view',
  mostPopularLinkView: 'Most Popular Link View',
  allLinkClick: 'All views',
  internalLinkClick: 'internal Link Click',
  externalLinkClick: 'External Link Click',
  allHit: 'All Hits',
  publishedDate: 'Published Date',
  todayHit: 'Today Hits',

  viewCount: 'View count',
  clickCount: 'Click count',
  viewColor: 'View',
  clickColor: 'Click',

  last24Hours: 'Last 24 Hours',
  last7Days: 'Last week',
  lastMonth: 'Last Month',

  countries: 'Countries',
  browsers: 'Browsers',
  os: 'Operating System',
  devices: 'Devices',
  refers: 'Refers',
  lastActivities: 'Last activities',
};

const alerts = {
  passwordNotEqualWithConfirm: 'Password and confirm password does not match',
  changePasswordSuccess: 'Password changed successfully!',
  addYourFirstLink: 'Make your first link and share it with your friends!',
  copiedInClipboard: 'Copied to clipboard.',
  deleteConfirmMessage: 'Are you sure you want to delete this item?',
};

const ads = {
  adsItem1: `Aren’t you professional yet?  By paying only 500,000 Tomans, you can enjoy the full facilities of Redlink, a professional. Redlink Gallery, Store and Resume Maker`,
  adsItem1Action: 'Get professional',
  adsItem2: `Follow Redlink on Instagram. To be informed of the latest features and new changes and do not miss the unique opportunities.`,
  adsItem2Action: 'View',
  adsItem3: `share your Redlink on Instagram bio, Tweeter and other social medias and give the access to your friends`,
  adsItem3Action: 'Read',
  adsItem4: `Follow Redlink on Instagram and win Xiaomi Mi-band 5 by introducing us to your friends.`,
  adsItem4Action: 'View',
};

export const en = {
  ...general,
  ...alerts,
  ...exceptions,
  ...limitations,
  ...resume,
  ...statistics,
  ...ads,

  messengers: 'Messengers',
  contactWays: 'contact ways',
  podcasts: 'Podcasts',
  profile: 'Profile',
  links: 'Links',
  templates: 'Add',
  shop: 'Shop',
  gallery: 'gallery',
  resume: 'Resume',
  theme: 'Theme',
  orders: 'Orders',
  dashboardCaption: 'Profile',
  profileCaption: 'Profile',
  linkCaption: 'Link',
  shopCaption: 'Shop',
  galleryCaption: 'gallery',
  resumeCaption: 'Resume',
  themeCaption: 'Theme',
  orderCaption: 'Orders',
  notSelected: 'Choose ...',
  moneyPostfix: 'Toman',
  addToCard: 'Add To Card',
  notAvailble: 'Not Availble',
  cases: 'case',
  reviewShoppingList: 'Complete the order',
  redlinkInstagram: 'Redlink Instagram',
  instagram: 'Instagram',
  social: 'Social Medias',
  virgool: 'Virgool',
  blog: 'Blog',
  name: 'Name',
  bio: 'Biography',
  email: 'Email',
  phoneNumber: 'Phone/mobile no.',
  address: 'Address',
  avatarImage: 'Avatar',
  avatarImageDescription:
    "Maximum Image dimensions 512x512 / It's better that the image size not be more than 444.",
  setting: 'setting',
  yourLink: ' RedLink address (personal link)',
  changePassword: 'Change password',
  newPassword: 'New password',
  confirmPassword: 'Confirm password',
  oldPassword: 'Old password',
  addNewLink: 'Add new link',
  addSeparator: 'Add Separator',
  totalHit: 'click',
  newLink: 'Add new link',
  title: 'Title',
  url: 'URL',
  shortLink: 'Specefic link',
  shortLinkDescription:
    'This link introduces you ! you can publish it on Instagram and other social networks.',
  add: 'save',
  products: 'Products',
  addNewProduct: 'New products',
  categories: 'Categories',
  categoriesGuideLine1: 'You can choose one of the categories',
  categoriesGuideLine2: ' Example: Graphic, product design, Illustration ...',
  linksGuideLine1: 'You can assign one or more links to the image',
  linksGuideLine2: 'For example, view link in other services',
  linksGuideLine3: 'Download links in different sizes',
  addNewCategory: 'Add category',
  categoryTitle: 'Category Title',
  withoutCategory: 'No category',
  newProduct: 'New Product',
  newCategory: 'New Category',
  description: 'Description',
  newPost: 'New Post',
  position: 'Position',

  posts: 'Posts',
  addNewPost: 'New Post',
  chooseYourTheme: 'Choose Theme',
  makeYourSpecialTheme: 'Make your specific theme',

  showSocialMedia: 'Show social medias',
  showSocialMediaDescription: '(5 social medias of links)',
  contactInfoProfileDescription: '(Mobile number, email, address)',

  newTheme: 'New Theme',
  login: 'login',
  register: 'register',
  continueWithGoogle: 'Continue with Google',
  password: 'Password',
  forgetYourPassword: 'forgot password?',
  upgrade: 'Be Pro to use more features!',
  freePlan: '- free -',
  proPlan: '- pro -',
  bePro: 'حرفه ای باش!',
  unlockTheOptions: 'Upgrade your account and shine!',
  from: 'From ',
  visit: ' visit',
  annually: 'annualy',
  annually2: 'annualy',
  tomanPostfix: 'toman',
  tomanPostfixSummary: 'ت',
  monthlyPrefix: 'معادل ماهانه',
  unlockPlan: 'upgrade',
  status: 'status',
  items: 'item',
  reserved: 'reserved',
  preview: 'preview',
  orderDetail: 'order detail',
  linkDisplay: 'Link Display, Effect view or Download',
  shortLinkSharePost: 'Short link for share post',
  shortLinkShare: 'Short link to share',
  profileInfo: 'profile info',
  titleNameOrCompany: 'Title (Name and Surname/ company or organization name)',
  contactInfo: 'contact info',
  orderStatusPackaging: 'Packing',
  orderStatusDelivery: 'Delivery',
  orderStatusNew: 'New',
  orderStatusDone: 'Done',
  orderStatusCancel: 'Cancel',
  notExist: 'Not entered',
  default: 'Active',
  selectLinkLogo: 'Icon',
  addYourFirstProduct: "Make your store's first product and start selling!",
  addYourFirstPost: 'Submit your first post and share it with others!',
  isAvailable: 'Available?',
  noOrdersExist: 'no orders available',
  setAsDefault: 'Choose as the main theme',
  defaultTheme: 'Main theme',
  proPlanSimple: 'Pro',
  proPlanExpireDaysPostfix: 'days remain',
  purchasePage: 'Purchase New Card(s)',
  card: 'Card(s)',
  watchTutorials: 'Watch tutorials!',
  productBasket: 'cart',
  totalPrice: 'total price',
  submitOrder: 'Submit the purchase request',
  contact: 'contact info',
  newOrderSuccess:
    'Your request has been successfully submitted. The seller will contact you as soon as possible based on your contact information.',
  contactTip:
    'Make sure your contact information is correct. The seller will contact you based on this information.',
  solutions: 'solutions',
  services: 'services',
  weblog: 'weblog(toturials)',
  priceAndPlans: 'prices and plans',
  support: 'support',
  redLinkSolutions: 'Redlink solutions',
  redLink: 'REDlink',
  solutionsEn: 'solutions',

  selectDefaultTab: 'Select the entry tab',
  selectDefaultTabDescription: `You can specify which tab to display first by tapping your link.
  The profile page is set up normally but links, store, gallery or resume may be more important to you.`,
  visibleTabs: 'Show tabs',
  visibleTabsDescription: `You have access to various features, each of which is displayed as a tab. You can disable the tabs you do not need.`,
  dontHaveAccount: `Don't have an account?`,
  registerFromHere: 'sign up ',
  haveAccount: 'already have an account?',
  loginFromHere: 'login',
  logout: 'log out',

  shopPlanDescription: 'You can only make your store in the pro plan',
  galleryPlanDescription: 'You can only make your gallery in the pro plan',
  resumePlanDescription: 'You can only make your resume in the pro plan',
  linksPlanDescription: 'this feature is free',
  profilePlanDescription: `In the free version it comes with links on one page
In the professional version, the Redlink logo is removed.`,
  themePlanDescription: 'this feature is free to use',

  reports: 'reports',
  users: 'users',
  pro: 'pro',
  basic: 'basic',

  account: 'Account',
  tags: 'Tags',
  tagDescription: '(It is not displayed but you are searchable with it)',
  showQRcode: 'show QRcode',
  registerDate: 'register date',
  expireDate: 'expire date',
  accountType: 'account type',
  actions: 'actions',

  usersCount: 'all users',
  proUsersCount: 'all pro users',
  income: 'Total revenue',
  todayIncome: 'today revenue',
  reload: 'update',
  usersRegister: 'users register',
  saleReport: 'sale chart',
  linksReport: 'links report',
  shopReport: 'shop report',
  galleryReport: 'gallery report',
  resumeReport: 'resume report',
  daily: 'daily',
  monthly: 'monthly',
  yearly: 'yearly',
  proAccount: 'pro account',
  basicAccount: 'free account',
  linksCount: 'Total links',
  activeLinksCount: 'number of Active links',
  linksClickCount: 'Number of clicks on links',
  avgLinksClickCount: 'Average clicks on each link',
  avgLinksPerUser: 'Average link per user',
  topTen: 'best',
  productCount: 'total products',
  activeProductCount: 'number of active products',
  ordersCount: 'total orders',
  avgOrdersPerShop: 'Average order per store',
  avgOrdersPerProduct: 'Average order per product',
  avgProductsPerUser: 'Average products per user',
  categoryCount: 'Number of categories',
  avgCategoryPerShop: 'Average category per store',
  avgProductPerCategory: 'Average product in each category',
  postCount: 'total posts',
  activePostCount: 'number of active posts',
  postsClickCount: 'Number of clicks on posts',
  avgClickPrePost: 'Average clicks on each post',
  avgPostPerUser: 'Average post per user',
  avgCategoryPerGallery: 'Average category per gallery',
  avgPostPerGallery: 'Average post in each category',
  pageName: 'specific address',
  addNewUser: 'add new user',
  deepSearch: 'advanced search',
  filter: 'filter',
  removeFilter: 'remove filter',
  totalOf: 'total ',
  isPro: 'is pro ?',
  newUser: 'new user',

  usingRedlink: 'Using redlink',
  shareDescriptionLine1: 'only Making a redlink is not important.',
  shareDescriptionLine2: 'Share your link on social medias.',
  shareDescriptionLine3:
    'You can also share your profile picture on social medias.',

  passwordManagement: 'Change password',
  signOut: 'Sign out',
  addPage: 'Add page',
  pages: 'Pages',
  deactivePages: 'Archives',
  deactivePagesDescription: 'Upgrade to Pro to use them',
  enterPage: 'Enter & Edit',
  renewPage: 'Renew Subscription',
  purchaseNewPage: 'Purchase New Page(s)',
  purchaseNewPageDescription:
    'می‌توانید برای یک یا چند کارت به زبان فارسی یا انگلیسی با تمام دسترسی‌ها ایجاد کنید. اگر می‌خواهید صفحه دومی برای خود یا بیزینس خود ایجاد کنید می‌توانید از این ویژگی ردلینک استفاده کنید.',
  newCardPlaceHolder: '- Pro Page -',
  pay: 'Purchase',
  addNewPage: 'New RedLink',
  addNewPageDescription:
    'می‌توانید یک کارت با زبان جدید و تمام دسترسی‌ها ایجاد کنید',
  newPageName: 'Redlink ID (Dedicated Link)',
  pageLanguage: 'Language',
  newPageNameDescription:
    'This link introduces you ! you can publish it on Instagram and other social networks.',
  upgradePlan: 'Upgrade Plan',

  goResume: 'My Resume',

  primaryButtonColorsTitle: 'Button',
  backgroundColorsTitle: 'Background',
  coverColorsTitle: 'Cover',
  textColorsTitle: 'Text',
  withGradiantOption: 'Gradiant Cover',
  primaryColor: 'Primary Button',
  saparatorColor: 'Saparator',
  titleColor: 'Title',
  subtitleColor: 'Subtitle',
  descriptionColor: 'Description',
  coverColor: 'Cover Color',
  coverTextColor: 'Cover Text',
  backgroundColor: 'Background',
  cardColor: 'Card',

  enterPhoneNumber: 'شماره تلفن خود را وارد کنید',
  getPhoneVerificationCode: 'دریافت کد فعالسازی',
  enterPhoneVerificationCode: 'کد فعالسازی خود را وارد کنید',
  sentVerificationCode: 'کد فعالسازی برای شماره تلفن شما ارسال شد',
  checkVerificationCode: 'فعالسازی و ورود',
  resendVerificationCode: 'ارسال مجدد کد فعالسازی',

  basicLimitationHintDescription:
    'تغییر این قسمت تنها در نسخه حرفه ای امکان پذیر می باشد.',

  planPageDescription:
    'ردلینک رایگانه و میتونی بصورت آماتور استفاده کنی اما اگر امکانات کامل نیاز داری! باید حرفه‌ای باشی :)',

  planItem1Prefix: 'ردلینک شخصی از',
  planItem1Content: '۴ حرف',

  planItem2Prefix: 'حذف محدودیت',
  planItem2Content: '۱۰ لینک',
  planItem2Postfix: 'رایگان',

  planItem3Prefix: 'حذف محدودیت',
  planItem3Content: '۵ پست',
  planItem3Postfix: 'برای گالری',

  planItem4Prefix: 'حذف محدودیت',
  planItem4Content: '۵ آیتم',
  planItem4Postfix: 'برای فروشگاه',

  planItem5Prefix: 'امکان',
  planItem5Content: 'شخصی‌سازی پوسته',

  planItem6Prefix: 'امکان',
  planItem6Content: 'شخصی‌سازی لینک',
  planItem6Postfix: 'در لینک‌ها، گالری‌ها و محصولات فروشگاه',

  planItem7Prefix: 'حذف محدودیت',
  planItem7Content: '۱ تصویر',
  planItem7Postfix: 'برای گالری و فروشگاه',

  planItem8Prefix: 'نمایش',
  planItem8Content: 'آمار حرفه‌ای و جامع',

  planItem9Prefix: 'حذف',
  planItem9Content: 'تبلیغات',

  planItem10Prefix: 'نمایش در صفحه اول و سئوی گوگل',

  commingSoon: 'به زودی',

  addShopContact: 'اطلاعات تماس فروشگاه',

  shopContactAddresses: 'آدرس',
  shopContactPhones: 'اطلاعات تماس',
  shopContactMessengers: 'پیام‌رسان‌ها',

  shopContact: {
    address: 'آدرس',
    telphone: 'تلفن ثابت',
    cellphone: 'تلفن همراه',
    email: 'پست الکترونیکی',
    telegram: 'Telegram',
    whatsapp: 'Whatsapp',
  },

  setupPageTitle: 'New RedLink',
  continue: 'Continue',

  setupPageLanguageTitle: 'Step 1',
  setupPageLanguageDescription: 'Select your page language',

  setupPageNameTitle: 'Step 2',
  setupPageNameDescription:
    'A RedLink is a unique link that you make available to everyone and reach you.',
  setupPageNameHints: `
- At least 6 characters
- You can use English letters, numbers, and characters.
- Changes cannot be made until 72 hours after selection.
  `,
  setupPageFullnameTitle: 'Step 3',
  setupPageFullnameDescription:
    'The title can be your name or your business name, which will be displayed to everyone.',

  setupPageAvatarTitle: 'Step 4',
  setupPageAvatarDescription: 'Choose your avatar image.',
  setupPageAvatarHints: `
- Maximum 1 MB
- Maximum dimensions 512x512
  `,

  setupPageTagsTitle: 'Last Step',
  setupPageTagsDescription: 'Identify your job or interest.',

  startPage: 'Start!',
};
